import React from 'react';
import { Button, Space } from 'antd';

export interface FormActionsProps {
  onCancel?: () => void;
  /** 破壞性動作（刪除），會跟 Save 拉開距離避免誤點 */
  onDelete?: () => void;
  submitting?: boolean;
  dirty?: boolean;
  submitLabel?: string;
  cancelLabel?: string;
  deleteLabel?: string;
  /** 為 true 時 footer sticky 到底部（full page form） */
  sticky?: boolean;
}

/**
 * 標準化 Save / Cancel / Delete footer。
 * - Save 永遠在右、primary
 * - Cancel 在左、secondary
 * - Delete（destructive）左側 + 與 Save 至少 32px gap
 * - dirty 時顯示「有未儲存變更」提示
 * - submitting 時 disable 防雙擊
 */
export const FormActions: React.FC<FormActionsProps> = ({
  onCancel,
  onDelete,
  submitting = false,
  dirty = false,
  submitLabel = '儲存',
  cancelLabel = '取消',
  deleteLabel = '刪除',
  sticky = false,
}) => {
  const style: React.CSSProperties = sticky
    ? {
        position: 'sticky',
        bottom: 0,
        marginTop: 24,
        padding: '12px 20px',
        background: 'var(--ant-color-bg-container, #fff)',
        borderTop: '1px solid var(--ant-color-border-secondary, #f0f0f0)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 32,
        zIndex: 10,
      }
    : {
        marginTop: 24,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 32,
      };

  return (
    <div style={style}>
      <div>
        {onDelete && (
          <Button danger onClick={onDelete} disabled={submitting}>
            {deleteLabel}
          </Button>
        )}
      </div>
      <Space>
        {dirty && !submitting && (
          <span style={{ fontSize: 12, color: 'rgba(0,0,0,0.55)', marginRight: 8 }}>
            有未儲存變更
          </span>
        )}
        {onCancel && (
          <Button onClick={onCancel} disabled={submitting}>
            {cancelLabel}
          </Button>
        )}
        <Button type="primary" htmlType="submit" loading={submitting}>
          {submitLabel}
        </Button>
      </Space>
    </div>
  );
};
